import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import store from '../store';

export const ToastWrapper = (Component) => (props) => (
  <React.Fragment>
    <Component {...props} />
    <ToastContainer />
  </React.Fragment>
);

export const ReduxWrapper = (Component) => (props) => (
  <Provider store={store}>
    <Component {...props} />
  </Provider>
);
